export default "__VITE_ASSET__sEGkuFx7__"